<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
          <h4>Организация</h4>
      </v-flex>
      <v-flex xs12>
        <v-tabs>
          <v-tab href="#tab-1">
            Основные данные
          </v-tab>
          <v-tab-item
                  :value="'tab-1'">
            <v-card>
<!--              <v-card-text>-->
                <v-container grid-list-md class="py-1">
                  <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field
                                v-model="this.reportTypeDepartment.report_department_info.name_short"
                                label="Организация"
                                readonly
                                :loading="listLoading.includes('reportingFetchReportTypeDepartmentCard_' + reportTypeDepartment.id)"
                                :append-outer-icon="'mdi-select-search'"
                                @click:append-outer="$router.push({name: 'reporting_report_department_list'})"
                        >
                        </v-text-field>
                    </v-flex>
                      <department-form
                              v-if="'report_department_info' in reportTypeDepartment"
                              :item="reportTypeDepartment.report_department_info">
                      </department-form>
                  </v-layout>
                </v-container>
<!--              </v-card-text>-->
            </v-card>
          </v-tab-item>
            <v-tab href="#tab-2">
                Системные данные
            </v-tab>
            <v-tab-item
                    :value="'tab-2'">
                <system-form :system-info=reportTypeDepartment></system-form>
            </v-tab-item>
        </v-tabs>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                      @click.native="save()">Сохранить
              </v-btn>
              <v-btn
                      v-if="this.$route.params.report_id !== 'new'"
                      @click.native="del">Удалить
              </v-btn>
              <v-btn @click.native="cancel">Отменить
              </v-btn>
          </v-card-actions>
      </v-flex>
        <v-flex xs12 md8>
            <router-view></router-view>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SystemForm from '../../common/systemForm'
import departmentForm from '../../common/departmentForm'

export default {
  components: { SystemForm, departmentForm },
  data () {
    return {
      menuFilter: false
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    reportTypeDepartment () {
      return this.$store.getters['reportingReport/reportTypeDepartment']
    },
    fullReportTypeDepartment () {
      if ('report_department_info' in this.reportTypeDepartment) {
        return this.reportTypeDepartment.report_department_info.name_short
      }
      return '---'
    }
  },
  methods: {
    initialize () {
      let id = this.$route.params.report_department_id
      if (id === 'new') {
        this.$store.commit('reportingReport/setDefaultReportTypeDepartment', {
          id: id,
          type_abbr: this.$route.params.typeAbbr
        })
      } else {
        this.$store.dispatch('reportingReport/fetchReportTypeDepartmentCard', {
          id: id })
      }
    },
    save () {
      this.$store.dispatch('reportingReport/insertReportTypeDepartment', this.reportTypeDepartment)
        .then(() => {
          if (this.$route.params.report_department_id === 'new') {
            this.$router.push({
              name: 'reporting_report_type_department_card',
              params: {
                report_department_id: this.reportTypeDepartment.id
              }
            })
          }
        }
        )
    },
    del () {
      if (this.reportTypeDepartment.id !== 'new') {
        this.$store.dispatch('reportingReport/deleteReportTypeDepartment', this.reportTypeDepartment.id)
          .then(() => {
            this.$router.push({ name: 'reporting_report_type_department_list' })
          })
      }
    },
    cancel () {
      this.$router.push({ name: 'reporting_report_type_department_list' })
    }
  },
  created: function () {
    if ((this.reportTypeDepartment['id'] === null) || ('' + this.reportTypeDepartment['id'] !== '' + this.$route.params.report_department_id)) {
      this.initialize()
    }
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .bloc_inline
  {
    display:inline-block;
  }
</style>
